import React from "react";
import { getItem }   from '../Storage';
import { Routes }    from '../navigation';
import { StyleUtils } from '../utils';
import '../css/salient.css';

export default class Header extends React.Component {

  render() {
    if (this.props.hide) {
      return null;
    }

    let partner   = getItem('partner');
    let title     = this.props.title;
    let subtitle  = this.props.subtitle;
    let logo_url  = partner && partner.logo_url ? partner.logo_url : 'https://teletailstest.s3.amazonaws.com/profile/1633529478005.png';

    let is_home_enabled = partner && partner.enable_home_screen ? partner.enable_home_screen : false;
    let display_home    = this.props.display_home_button === true ? true : false;
        display_home    = is_home_enabled && display_home ? true : display_home;

    let root_style = {
      '--ch-accent':      StyleUtils.get_header_color(),
      '--ch-grad-start':  StyleUtils.get_header_gradient_start(),
      '--ch-grad-end':    StyleUtils.get_header_gradient_end(),
      '--ch-accent-text': StyleUtils.get_header_text_color_auto(),
      '--ch-button':      StyleUtils.get_button_color(),
      '--ch-button-text': StyleUtils.get_button_text_color_auto(),
      '--ch-primary':     StyleUtils.get_primary_color(),
    };

    let hero_class = 'sln-hero' + (this.props.flush === true ? ' sln-hero--flush' : '');

    return <div className={ hero_class } style={root_style}>
      <div className='sln-hero-top'>
        <div className='sln-hero-logo-chip'>
          <img className='sln-hero-logo' src={ logo_url } alt='' />
        </div>
        { display_home ? <div className='sln-hero-home sln-pressable'
                              onClick={ () => {
                                let partner_code = partner && partner.code ? partner.code : '';
                                this.props.navigate(Routes.HOME + partner_code)
                              }}>
                           <span className='fas fa-home' />
                           <span>Home</span>
                         </div>
          : ( this.props.on_back ? <div className='sln-hero-homebtn sln-pressable' onClick={ this.props.on_back }>
                                     <span className='fas fa-home' />
                                   </div> : null ) }
      </div>
      { (title || subtitle) ? <div className='sln-hero-greeting'>
          { title ? <span className='sln-hero-title'>{ title }</span> : null }
          { subtitle ? <span className='sln-hero-subtitle'>{ subtitle }</span> : null }
        </div> : null }
    </div>
  }
}
